var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "timer",
      class: { "timer--start": _vm.isActive && !_vm.isIE },
      style: "animation-duration:" + _vm.duration + "ms",
      attrs: { viewBox: "0 0 36 36", xmlns: "http://www.w3.org/2000/svg" }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M18 2.0845 a15.9155 15.9155 0 0 0 0 31.831 a15.9155 15.9155 0 0 0 0 -31.831",
          fill: "none",
          "stroke-width": "3"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }